import Page from "../components/Page.vue";
import Preload from './Preload'

export default {
	mixins : [Preload],
	data() {
		return {
			page_loading : false,
			page_error : null,
		}
	},
	components : {
		Page,
	},
	beforeMount(){
		if(this.preload_error){
			this.page_error = this.preload_error;
		}
	},
};